import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/app.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Bow and Arrow: missing #root mount node in index.html");
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
